import React, { Component, Dispatch } from 'react';
import { Log } from 'ng2-logger';
import Translator from '../../../core/i18n';
import { Common } from '../../../core/common';
import { IAction, IAppState } from '../../../models/action/core';
import { connect } from 'react-redux';
import { IMatchingProps, IMatchingState } from '../../../models/components/add-question';
import Quil from '../../../components/input/quil/main';
import FileUpload from '../../../components/file-upload/main';
import BaseModalStatic from '../../../modal/base-modal/main-static';
import { FileService } from '../../../api/file-service';
import { Confirm, Notification } from '../../../components/notification/main';
import { BaseFields } from './baseFields';
import { IQuestionChoice, IQuestionData } from '../../../models/components/questions';
import { FormikProps } from 'formik';
import { ActivityTypeEnums } from '../../../models/enums/ActivityType';

const T = Translator.create();
const _logger = Log.create('Matching');
let _common: Common;
const _fileService = new FileService();
const portal = document.createElement('div');
document.body.appendChild(portal);

class Matching extends Component<IMatchingProps, IMatchingState> {
    constructor(props: any) {
        super(props);
        _common = new Common();

        this.state = {
            questionListPadding: 10,
            textChoices: [],
            fileChoices: []
        };
    }

    public onChangeQuestionChoiceType = (selectValue: 0 | 1, formik: FormikProps<IQuestionData>) => {
        if (formik.values.isExamQuestion) {
            Notification.setNotification(
                'error',
                T.t('r_api_gen_question_error_not_editable_exam_question'),
                'topRight'
            );
            return;
        }
        formik.setFieldValue('questionChoiceType', selectValue);

        if (selectValue) {
            this.setState({ textChoices: formik.values.choices });
            formik.setFieldValue('choices', this.state.fileChoices);
        } else {
            this.setState({ fileChoices: formik.values.choices });
            formik.setFieldValue('choices', this.state.textChoices);
        }
    };

    public addChoices = (formik: FormikProps<IQuestionData>) => {
        if (formik.values.isExamQuestion) {
            Notification.setNotification(
                'error',
                T.t('r_api_gen_question_error_not_editable_exam_question'),
                'topRight'
            );
            return;
        }
        let endDisplayOrder = 0;
        let endLeftIndex = 1;
        let endRightIndex = 1;

        if (formik.values.choices.length > 0) {
            endDisplayOrder = formik.values.choices.sort((a, b) => b.displayOrder - a.displayOrder)[0].displayOrder + 1;
            endLeftIndex = formik.values.choices.filter(choice => choice.side === 0).length + 1;
            endRightIndex = formik.values.choices.filter(choice => choice.side === 1).length + 1;
        }

        const _choiceList = formik.values.choices;
        const leftSideChoice: IQuestionChoice = {
            inputId: '',
            choiceFileId: '',
            choiceFile: '',
            isCorrect: false,
            choiceText: '',
            optionText: '' + endLeftIndex,
            fileInputKey: this.props.fileInputKey + endDisplayOrder,
            displayOrder: endDisplayOrder,
            side: 0,
            sortOrder: 0
        };

        const rightSideChoice: IQuestionChoice = {
            inputId: '',
            choiceFileId: '',
            choiceFile: '',
            isCorrect: false,
            choiceText: '',
            optionText: String.fromCharCode(64 + endRightIndex),
            fileInputKey: this.props.fileInputKey + endDisplayOrder + 1,
            displayOrder: endDisplayOrder + 1,
            side: 1,
            sortOrder: endLeftIndex
        };

        _choiceList.push(leftSideChoice);
        _choiceList.push(rightSideChoice);
        formik.setFieldValue('choices', _choiceList);
    };

    deleteChoice = (choice: IQuestionChoice) => {
        if (this.props.formik.values.isExamQuestion) {
            Notification.setNotification(
                'error',
                T.t('r_api_gen_question_error_not_editable_exam_question'),
                'topRight'
            );
            return;
        }
        Confirm.setConfirm(
            'normal',
            () => this.deleteConfirmed(choice.displayOrder),
            T.t('r_delete_question_choice'),
            null,
            null,
            undefined,
            true
        );
    };

    deleteConfirmed = (displayOrder: number) => {
        const _choiceList = this.props.formik.values.choices.sort((a, b) => a.displayOrder - b.displayOrder);
        const sourceItemLeftChoiceIndex = _choiceList.findIndex(q => q.displayOrder === displayOrder && q.side === 0);

        if (sourceItemLeftChoiceIndex !== -1) {
            _choiceList.splice(sourceItemLeftChoiceIndex, 2);
            _choiceList
                .filter(q => q.displayOrder > displayOrder && q.side === 0)
                .forEach(item => {
                    item.displayOrder = item.displayOrder - 2;
                    item.optionText = '' + (parseInt(item.optionText, 10) - 1);
                });

            _choiceList
                .filter(q => q.displayOrder > displayOrder && q.side === 1)
                .forEach(item => {
                    item.displayOrder = item.displayOrder - 2;
                    item.optionText = String.fromCharCode(
                        64 + _choiceList.filter(q => q.side === 1).findIndex(choice => choice.displayOrder === item.displayOrder) + 1
                    );
                    item.sortOrder = item.sortOrder - 1;
                });

            this.props.formik.setFieldValue('choices', _choiceList);
        }
    };

    public choiseInputOnChange = (e: any, choice: IQuestionChoice, formik: FormikProps<IQuestionData>) => {
        if (e) {
            const choices = formik.values.choices;
            if (choices.length > 0) {
                const _choice = choices.find(x => x.displayOrder === choice.displayOrder);
                if (_choice) {
                    _choice.choiceText = e;
                    this.editChoice(_choice, formik);
                }
            }
        }
    };

    public editChoice = (choice: IQuestionChoice, formik: FormikProps<IQuestionData>) => {
        const _choiceList = formik.values.choices.sort((a, b) => a.displayOrder - b.displayOrder);
        if (_choiceList.length > 0) {
            const sourceItemIndex = _choiceList.findIndex(q => q.displayOrder === choice.displayOrder);
            if (sourceItemIndex !== -1) {
                _choiceList.splice(sourceItemIndex, 1);
                _choiceList.push(choice);
                formik.setFieldValue('choices', _choiceList);
            }
        }
    };

    componentDidMount() {
        if (this.props.formik && this.props.formik.values && this.props.formik.values.choices) {
            this.props.formik.values.choices.forEach(choice => {
                if (choice.choiceFile && choice.choiceFileId) {
                    void _common.GetImageUrl(choice.choiceFile).then((url: any) => {
                        choice.fileInputKey = this.props.fileInputKey + choice.displayOrder;
                        choice.isPreviewFile = true;
                        choice.file = url;
                        this.editChoice(choice, this.props.formik);
                        this.props.formik.setFieldValue('questionChoiceType', 1);
                    });
                }
            });
        }
    }

    triggerModal = (choice: IQuestionChoice, formik: FormikProps<IQuestionData>, value: boolean) => {
        if (formik && formik.values) {
            const choices = formik.values.choices;
            const _choice = choices.find(x => x.displayOrder === choice.displayOrder);
            if (_choice) {
                _choice.isModalOpen = value;
                this.editChoice(_choice, formik);
            }
        }
    };

    getFileAsync = async (fileName: string, choice: IQuestionChoice, formik: FormikProps<IQuestionData>, fileInputKey: string) => {
        const params = { fileUploadId: fileInputKey, fileName };
        const choices = formik.values.choices;
        const _choice = choices.find(x => x.displayOrder === choice.displayOrder);

        if (_choice) {
            await _fileService
                .RequestGetFileAsync({ ...params })
                .then((response: Response) => {
                    if (response.status !== 200) {
                        _choice.isPreviewFile = false;
                        _choice.file = '';
                        this.editChoice(_choice, formik);
                    }
                    return response.json();
                })
                .then((responseData: any) => {
                    _choice.isPreviewFile = true;
                    _choice.file = responseData;
                    this.editChoice(_choice, formik);
                    this.triggerModal(choice, formik, false);
                })
                .catch(() => {
                    _choice.isPreviewFile = false;
                    _choice.file = 'responseData';
                    this.editChoice(_choice, formik);
                });
        }
    };

    afterFileUploadChoice = async (file: any, choice: IQuestionChoice, formik: FormikProps<IQuestionData>, fileInputKey: string) => {
        if (formik && formik.values) {
            const choices = formik.values.choices;
            const _choice = choices.find(x => x.displayOrder === choice.displayOrder);

            if (file && _choice) {
                _choice._file = file;
                this.editChoice(_choice, this.props.formik);
                await this.getFileAsync(file.name, choice, formik, fileInputKey);
            }
        }
    };

    afterFileDeleteChoice = async (choice: IQuestionChoice, formik: FormikProps<IQuestionData>) => {
        if (formik && formik.values) {
            const choices = formik.values.choices;
            const _choice = choices.find(x => x.displayOrder === choice.displayOrder);

            if (_choice) {
                _choice.isPreviewFile = false;
                _choice.file = '';
                this.editChoice(_choice, this.props.formik);
            }
        }
    };

    public handleDeleteFileConfirm = (choice: IQuestionChoice, formik: FormikProps<IQuestionData>) => {
        if (formik.values.isExamQuestion) {
            Notification.setNotification(
                'error',
                T.t('r_api_gen_question_error_not_editable_exam_question'),
                'topRight'
            );
            return;
        }
        Confirm.setConfirm(
            'normal',
            () => this.handleDeleteFile(choice.displayOrder, formik),
            T.t('r_confirm_delete_photo'),
            null,
            null,
            undefined,
            true
        );
    };

    handleDeleteFile = (displayOrder: number, formik: FormikProps<IQuestionData>) => {
        const choices = formik.values.choices;
        const choice = choices.find(x => x.displayOrder === displayOrder);

        if (choice) {
            if (choice._file) {
                choice.willDeleteFile = choice._file;
            } else {
                choice.isPreviewFile = false;
                choice.file = '';
                this.props.formik.setFieldValue('questionFileId', '');
            }
            this.editChoice(choice, this.props.formik);
        }
    };

    choicesPortalAwareItem = (choice: IQuestionChoice, index: number, choices: IQuestionChoice[]) => {
        let child;
        switch (this.props.formik && this.props.formik.values && this.props.formik.values.questionChoiceType) {
            case 0:
                child = (
                    <React.Fragment>
                        <div className="answer_type_text" id={'choices_' + index} style={{ height: 'auto' }}>
                            <div
                                className={'control_group_answer w-40 survey_choose mr-2 ' + (choice.isCorrect ? 'choosed-2' : '')}
                                style={{ float: 'left', height: 'auto' }}
                            >
                                <span style={{ minWidth: 'max-content' }}>{choice.optionText})</span>
                                <Quil
                                    modules={'basic'}
                                    placeholder={T.t('r_gen_questionBank_choise_text_paceholder') + " *"}
                                    // tslint:disable-next-line: jsx-no-lambda
                                    onChange={(e: any) => this.choiseInputOnChange(e, choice, this.props.formik)}
                                    value={choice.choiceText}
                                    theme={'bubble'}
                                    className="answer-input border-0 input-15"
                                    readonly={this.props.formik.values.isExamQuestion}
                                />
                            </div>

                            <a
                                className="mr-2 cursor-default"
                                style={{ float: 'left', height: '100%', display: 'flex', alignItems: 'center' }}
                            >
                                <i className="material-icons close_icon" style={{ color: '#c9c8c5', fontSize: 16 }}>
                                    arrow_forward
                                </i>
                            </a>
                            {choices
                                .filter(_choice => _choice.side === 1 && _choice.sortOrder.toString() === choice.optionText)
                                .map((item, _index) => (
                                    <div
                                        className={'control_group_answer w-40 survey_choose ' + (item.isCorrect ? 'choosed-2' : '')}
                                        style={{ float: 'left', height: 'auto' }}
                                        key={_index}
                                    >
                                        <span style={{ minWidth: 'max-content' }}>{item.optionText})</span>
                                        <Quil
                                            modules={'basic'}
                                            placeholder={T.t('r_gen_questionBank_choise_text_paceholder') + " *"}
                                            // tslint:disable-next-line: jsx-no-lambda
                                            onChange={(e: any) => this.choiseInputOnChange(e, item, this.props.formik)}
                                            value={item.choiceText}
                                            theme={'bubble'}
                                            className="answer-input border-0 input-15"
                                            readonly={this.props.formik.values.isExamQuestion}
                                        />
                                    </div>
                                ))}

                            <div
                                className="w-10"
                                style={{
                                    float: 'right',
                                    boxShadow: '0 1px 2px rgb(0 0 0 / 10%)',
                                    borderRadius: 8
                                }}
                            >
                                <div
                                    className="btn_container center"
                                    style={{
                                        borderRadius: 8
                                    }}
                                >
                                    <span className="delete_btn" onClick={this.deleteChoice.bind(this, choice)}>
                                        <i className="material-icons">close</i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </React.Fragment>
                );
                break;
            case 1:
                child = (
                    <React.Fragment>
                        <div className="answer_type_text" id={'choices_' + index}>
                            <div className="w-40 mr-2" style={{ float: 'left' }}>
                                <div
                                    className={'control_group_answer survey_choose ' + (choice.isCorrect ? 'choosed-2' : '')}
                                    style={{ float: 'left' }}
                                >
                                    <span style={{ minWidth: 'max-content', marginRight: 5 }}>{choice.optionText})</span>
                                    <a
                                        className="attachment-btn text-left attachment-btn-custom"
                                        type="button"
                                        aria-expanded="false"
                                        style={{ background: 'white', cursor: 'default !important', paddingTop: 12 }}
                                    >
                                        <i className="material-icons mr-2">attach_file</i>
                                        {T.t('r_question_add_photo_before_choice_text')}{' '}
                                        <span
                                            className="text-azure"
                                            onClick={() => {
                                                if (this.props.formik.values.isExamQuestion) {
                                                    Notification.setNotification(
                                                        'error',
                                                        T.t('r_api_gen_question_error_not_editable_exam_question'),
                                                        'topRight'
                                                    );
                                                }
                                                else {
                                                    this.triggerModal(choice, this.props.formik, true)
                                                }
                                            }}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            {' '}
                                            {T.t('r_question_add_photo_after_text')}
                                        </span>
                                    </a>
                                </div>

                                {choice.isPreviewFile ? (
                                    <div
                                        className="col-12 uploaded_file_container mt-4"
                                        style={{ display: 'flex', height: 300, justifyContent: 'center' }}
                                    >
                                        <div className="uploaded_file">
                                            <img src={choice.file} style={{ width: '100%', height: '100%' }} />
                                            <a
                                                onClick={this.handleDeleteFileConfirm.bind(this, choice, this.props.formik)}
                                                className="file_delete_btn"
                                            >
                                                <i className="material-icons">close</i>
                                            </a>
                                        </div>
                                    </div>
                                ) : (
                                    ''
                                )}
                            </div>

                            <a
                                className="mr-2 cursor-default"
                                style={{ float: 'left', height: '100%', display: 'flex', alignItems: 'start', marginTop: 25 }}
                            >
                                <i className="material-icons close_icon" style={{ color: '#c9c8c5', fontSize: 16 }}>
                                    arrow_forward
                                </i>
                            </a>

                            {choices
                                .filter(_choice => _choice.side === 1 && _choice.sortOrder.toString() === choice.optionText)
                                .map((item, _index) => (
                                    <div className="w-40 mr-4" style={{ float: 'left' }} key={index}>
                                        <div
                                            className={'control_group_answer survey_choose mr-4 ' + (item.isCorrect ? 'choosed-2' : '')}
                                            style={{ float: 'left' }}
                                        >
                                            <span style={{ minWidth: 'max-content', marginRight: 5 }}>{item.optionText})</span>
                                            <a
                                                className="attachment-btn text-left attachment-btn-custom"
                                                type="button"
                                                aria-expanded="false"
                                                style={{ background: 'white', cursor: 'default !important', paddingTop: 12 }}
                                            >
                                                <i className="material-icons mr-2">attach_file</i>
                                                {T.t('r_question_add_photo_before_choice')}{' '}
                                                <span
                                                    className="text-azure"
                                                    onClick={() => {
                                                        if (this.props.formik.values.isExamQuestion) {
                                                            Notification.setNotification(
                                                                'error',
                                                                T.t('r_api_gen_question_error_not_editable_exam_question'),
                                                                'topRight'
                                                            );
                                                        }
                                                        else {
                                                            this.triggerModal(item, this.props.formik, true)
                                                        }
                                                    }}
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    {' '}
                                                    {T.t('r_question_add_photo_after')}
                                                </span>
                                            </a>
                                        </div>

                                        {item.isPreviewFile ? (
                                            <div
                                                className="col-12 uploaded_file_container mt-4"
                                                style={{ display: 'flex', height: 300, justifyContent: 'center' }}
                                            >
                                                <div className="uploaded_file">
                                                    <img src={item.file} style={{ width: '100%', height: '100%' }} />
                                                    <a
                                                        onClick={this.handleDeleteFileConfirm.bind(this, item, this.props.formik)}
                                                        className="file_delete_btn"
                                                    >
                                                        <i className="material-icons">close</i>
                                                    </a>
                                                </div>
                                            </div>
                                        ) : (
                                            ''
                                        )}

                                        <BaseModalStatic
                                            minWidth={650}
                                            modalIsOpen={item.isModalOpen}
                                            onClose={this.triggerModal.bind(this, item, this.props.formik, false)}
                                            headerState={T.t('r_report_template_modal_header')}
                                            headerIcon={'clock'}
                                            modalBodyClassName={'modal-body pt-2 file-upload-modal-body'}
                                            modalHeaderClassName={
                                                'modal-header border-0 d-flex justify-content-between p-0 file-upload-modal-header'
                                            }
                                            modalContentClassName={'modal-content file-upload-modal-content'}
                                        >
                                            <FileUpload
                                                key={item.fileInputKey}
                                                fileInputKey={item.fileInputKey}
                                                height={400}
                                                maxFileSize={2000000000}
                                                maxSelectedFileCount={1}
                                                isCardImage={false}
                                                formik={this.props.formik}
                                                fileTypes={".png,.jpg,.jpeg"}
                                                afterFileUploadChoice={this.afterFileUploadChoice}
                                                afterFileDeleteChoice={this.afterFileDeleteChoice}
                                                willDeleteFile={item.willDeleteFile}
                                                choice={item}
                                            />
                                        </BaseModalStatic>
                                    </div>
                                ))}

                            <div
                                className="w-10"
                                style={{
                                    float: 'right',
                                    boxShadow: '0 1px 2px rgb(0 0 0 / 10%)',
                                    borderRadius: 8
                                }}
                            >
                                <div
                                    className="btn_container center"
                                    style={{
                                        borderRadius: 8
                                    }}
                                >
                                    <span className="delete_btn" onClick={this.deleteChoice.bind(this, choice)}>
                                        <i className="material-icons">close</i>
                                    </span>
                                </div>
                            </div>

                            <BaseModalStatic
                                minWidth={650}
                                modalIsOpen={choice.isModalOpen}
                                onClose={this.triggerModal.bind(this, choice, this.props.formik, false)}
                                headerState={T.t('r_report_template_modal_header')}
                                headerIcon={'clock'}
                                modalBodyClassName={'modal-body pt-2 file-upload-modal-body'}
                                modalHeaderClassName={'modal-header border-0 d-flex justify-content-between p-0 file-upload-modal-header'}
                                modalContentClassName={'modal-content file-upload-modal-content'}
                            >
                                <FileUpload
                                    key={choice.fileInputKey}
                                    fileInputKey={choice.fileInputKey}
                                    height={400}
                                    maxFileSize={2000000000}
                                    maxSelectedFileCount={1}
                                    isCardImage={false}
                                    formik={this.props.formik}
                                    fileTypes={".png,.jpg,.jpeg"}
                                    afterFileUploadChoice={this.afterFileUploadChoice}
                                    afterFileDeleteChoice={this.afterFileDeleteChoice}
                                    willDeleteFile={choice.willDeleteFile}
                                    choice={choice}
                                />
                            </BaseModalStatic>
                        </div>
                    </React.Fragment>
                );
                break;
            default:
                break;
        }

        return child;
    };

    public render() {
        return (
            <div id="st4" className="sorutipi col">
                <BaseFields formik={this.props.formik} isFromMadlen={this.props.isFromMadlen} fileInputKey={this.props.fileInputKey} />

                {!this.props.isFromMadlen &&
                    <>
                        <div className="row mt-4">
                            <div className="col-12">
                                <span className="new-subtitle">{T.t('r_gen_questionBank_choise_type')} <span className="ml-1" style={{ color: '#dc5050' }}>* </span></span>
                            </div>
                            <div className="col-md-12 col-12 difficulties" style={{ marginTop: 20 }}>
                                <div className="control_group survey_choose mr-4">
                                    <label
                                        className="control control--radio"
                                        htmlFor={T.t('r_gen_questionBank_choise_type_text')}
                                        onClick={this.onChangeQuestionChoiceType.bind(this, 0, this.props.formik)}
                                    >
                                        {T.t('r_gen_questionBank_choise_type_text')}
                                        <input
                                            type="checkbox"
                                            name={'choiseType'}
                                            value={0}
                                            id={'Yazi'}
                                            checked={
                                                this.props.formik && this.props.formik.values && this.props.formik.values.questionChoiceType === 0
                                            }
                                            className="form-radio"
                                            style={{ borderRadius: 100 }}
                                        />
                                        <div className="control__indicator" />
                                    </label>
                                </div>
                                {/* <div className="control_group survey_choose mr-4">
                            <label
                                className="control control--radio"
                                htmlFor={T.t('r_gen_questionBank_choise_type_photo')}
                                onClick={this.onChangeQuestionChoiceType.bind(this, 1, this.props.formik)}
                            >
                                {T.t('r_gen_questionBank_choise_type_photo')}
                                <input
                                    type="checkbox"
                                    name={'choiseType'}
                                    value={1}
                                    id={'Fotograf'}
                                    checked={
                                        this.props.formik && this.props.formik.values && this.props.formik.values.questionChoiceType === 1
                                    }
                                    className="form-radio"
                                    style={{ borderRadius: 100 }}
                                />
                                <div className="control__indicator" />
                            </label>
                        </div> */}
                            </div>
                        </div>
                        <div className="row" style={{ paddingBottom: this.state.questionListPadding }}>
                            {this.props.formik.values.choices
                                .filter(choice => choice.side === 0)
                                .sort((a, b) => a.displayOrder - b.displayOrder)
                                .map((item, index) => (
                                    <React.Fragment key={index}>
                                        {this.choicesPortalAwareItem(item, index, this.props.formik.values.choices)}
                                    </React.Fragment>
                                ))}
                        </div>
                        <div className="row mt-4">
                            <div className="col-12 cevap_list" style={{ padding: 0 }}>
                                <div className="col-12 answerText">
                                    <a
                                        // tslint:disable-next-line
                                        onClick={this.addChoices.bind(this, this.props.formik)}
                                        className="attachment-btn"
                                        type="button"
                                        aria-expanded="false"
                                    >
                                        <i className="material-icons mr-2">add</i>
                                        {T.t('r_gen_questionBank_newChoise')}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </>
                }
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IMatchingProps): IMatchingProps => {
    if (!state) {
        return ownProps;
    }

    const newProps: IMatchingProps = Object.assign({}, ownProps, {
        coursePageActivityId: state.coursePage.coursePageActivityId,
        coursePageClassId: state.coursePage.coursePageClassId
    });

    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret =
        next.coursePage.coursePageActivityId === prev.coursePage.coursePageActivityId &&
        next.coursePage.coursePageClassId === prev.coursePage.coursePageClassId;
    return ret;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const CMatching = connect(mapStateToProps, dispatchProps, null, {
    areStatesEqual
})(Matching);

export default CMatching;
